import React, { useEffect, useRef, useState } from "react";
import { TiTick } from "react-icons/ti";
import "./style.css";
import BannerSvg from "../../assets/images/UIUX-of-a-mobile-app.webp";
import BannerSvgMobile from "../../assets/images/UIUX-of-a-mobile-app-300.webp";
import { routes } from "../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import GetAQuoteButton from "../../components/GetAQuoteButton";
import { motion } from "framer-motion";
  
function HomeBanner() {
  return (  
    <div className=" h-screen   md:h-auto md:pb-36 home-banner-wrapper ">
      <div className="relative relative-div">
        <div className=" bg-gradient-to-br from-[#6D1349] to-[#DF73FF]  h-[73vh] md:h-full  clip-box  custom-gradient-box">
          <div className="container h-full relative z-50  flex  relative-div custom-flex-container">
            <div className=" text-white flex items-center   md:pt-40 lg:pt-40 h-full  pb-12 md:pb-8 text-section-wrapper">
              <div className=" space-y-7 md:space-y-8 custom-vertical-space">
                <h1 className="block text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px] leading-[1] font-bold md:w-8/12 custom-heading ">
                  Catalyzing Innovation and Smart Digital Solutions
                </h1>
                <div className="pr-2 md:w-8/12 lg:w-7/12  sub-text-wrapper">
                  <h2 className="block text-[20px] md:text-[26px] lg:text-[25px] xl:text-[32px] 2xl:text-[32px] leading-[1]  custom-subheading">
                    {" "}
                    To solve challenges faced by businesses and to kick-start
                    their online journeys.
                  </h2>
                </div>

                {/* <div>
                <GetAQuoteButton  text="Get Started"/>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`absolute left-1/2 translate-x-[-50%] z10 -bottom-24 mobileLargeScreen:-bottom-13
     md:top-[60%] lg:top-[60%] xl:top-[58%]  pointer-events-none    
     container custom-absolute `}
        >
          {/* <img
            src={BannerSvg}
            srcSet={`
      ${BannerSvgMobile} 300w,
      ${BannerSvg} 538w
    `}
            sizes="(max-width: 640px) 256px, (max-width: 1024px) 288px, 352px"
            alt="Screens of a mobile app with a beautiful UI/UX design and Fintech functionalities."
             width={256}  
    height={450} 
            fetchPriority="high"
            loading="eager"
            className={`ml-auto  object-contain w-[16rem] mobileLargeScreen:w-[18rem] md:w-[18rem] lg:w-[22rem]   `}
          /> */}
          {/* <img
            src={BannerSvg}
            alt="Screens of a mobile app with a beautiful UI/UX design and Fintech functionalities."
            width={256}
            height={450}
               fetchPriority="high"
            loading="eager"
              decoding="async"
            className={`ml-auto  object-contain w-[16rem] mobileLargeScreen:w-[18rem] md:w-[18rem] lg:w-[22rem]   `}
          /> */}
          <img
  src={BannerSvg}
            alt="Screens of a mobile app with a beautiful UI/UX design and Fintech functionalities."
  width={256}
  height={450}
  fetchPriority="high"
  loading="eager"
  decoding="async"
  srcSet={`
    ${BannerSvg} 256w,
    ${BannerSvg} 512w,
    ${BannerSvg} 768w,
    ${BannerSvg} 1024w,
    ${BannerSvg} 1536w,
    ${BannerSvg} 1920w
  `}
  sizes="(max-width: 768px) 100vw, 768px"
            className={`ml-auto  object-contain w-[16rem] mobileLargeScreen:w-[18rem] md:w-[18rem] lg:w-[22rem] custom-image `}
/>

        </div>
      </div>
    </div>
  );
}

export default HomeBanner;
